module.exports = __webpack_public_path__ + "img/ic_ofuro.c9c854b7.svg";